import { render, staticRenderFns } from "./SelectableCapture.vue?vue&type=template&id=515b0b96"
import script from "./SelectableCapture.vue?vue&type=script&lang=js"
export * from "./SelectableCapture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports